import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Button} from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import { headerDataRH } from "../../../data/modules/hr-header";
import { useNavigate } from 'react-router-dom';
import TimeTrackingService from "../../../services/TimeTrackingService";
import { DataGrid } from "@material-ui/data-grid";
import Message from "../../tools/Message";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination} from '@mui/material';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
        elevation: 0,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export default function TimetrackingtousTable(props) {
    const classes = useStyles();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
    });
    const { open, color, messageInfo } = message;
    const [isLoading,setIsloading]=useState(false);
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setIsloading(true);
        TimeTrackingService.trackingtousaffiche().then((results) => {
            if (results) {
                  setList(results.data);
            } else {
                setList([]);
            }
            setIsloading(false);
        }).catch(() => {
            setIsloading(false);
        });
    }

    function handleClick() {
        navigate('/timetrackingtous');
    }

   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);


    const paginatedList = (list || []).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const columns = [
    { field: 'nom', headerName: 'Nom et prénom(s)', width: 300 },
    { field: 'datetracking', headerName: 'Date du pointage', width: 200 },
    { field: 'entree', headerName: 'Entrée', width: 200 },
    { field: 'sortie', headerName: 'Sortie', width: 200 },
    { field: 'motifinsert', headerName: 'Motif', width: 350 },
    { field: 'sup', headerName: 'Personne insérant', width: 350 },
  ];

    function handleCloseMessage() {
        setMessage({ ...message, open: false });
    }

    return (
        <MainContainer {...headerDataRH}>
            <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
            <Grid container spacing={3}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleClick}
                    style={{ fontWeight: 600 }}
                >
                    CREER
                </Button>
            </Grid>
            <h1 style={{ textAlign: 'center', color: '#4682B4' }}>Liste des pointages exceptionnels</h1>
            <Spacer y={2} />
            <Grid item xs={12}>
                  <TableContainer component={Paper} style={{ width: '100%' }}>
                    <Table aria-label="custom table">
                        <TableHead>
                        <TableRow>
                            {columns.map((col) => (
                            <TableCell key={col.field} style={{ width: col.width }}>
                                {col.headerName}
                            </TableCell>
                            ))}
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {!isLoading ? (
                            paginatedList.length > 0 ? (
                            paginatedList.map((row, index) => (
                                <TableRow key={index}>
                                {columns.map((col) => (
                                    <TableCell key={col.field}>{row[col.field]}</TableCell>
                                ))}
                                </TableRow>
                            ))
                            ) : (
                            <TableRow>
                                <TableCell colSpan={columns.length} style={{ textAlign: 'center' }}>
                                Aucune donnée disponible
                                </TableCell>
                            </TableRow>
                            )
                        ) : (
                            <TableRow>
                            <TableCell colSpan={columns.length} style={{ textAlign: 'center' }}>
                                Chargement...
                            </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]} 
                        component="div"
                        count={list ? list.length : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage="Lignes par page:"
                        labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} sur ${count}`
                        }
                    />
                    </TableContainer>
            </Grid>
        </MainContainer>
    );
}